import { FormControl as MUIFormControl } from '@mui/material';
import styled, { css } from 'styled-components';

export const StyledFormControl = styled(MUIFormControl)<{
  $fullWidth?: boolean;
  $gridColumnGap?: string;
  $gridColumns?: number | string;
  $labelPlacement?: 'bottom' | 'end' | 'image-uploader' | 'start' | 'toggle-end' | 'toggle' | 'top';
  $lineHeight?: string;
  $multilineLabel?: boolean;
  $width?: string;
}>`
  ${({ $gridColumns, $gridColumnGap, $labelPlacement, $width, $fullWidth, $multilineLabel, $lineHeight }) => css`
    display: grid;
    grid-template-columns: repeat(${$gridColumns ?? 6}, 1fr);
    width: ${$width ?? '100%'};
    grid-column-gap: ${$gridColumnGap ?? 'var(--sizes-60)'};
    align-items: center;
    .MuiInputBase-input {
      font: var(--font-regular-14pt-normal);
    }

    ${$labelPlacement === 'top' &&
    css`
      display: flex;
      flex-direction: column;

      .MuiInputBase-input {
        font: var(--font-small-13pt-normal);
        line-height: ${$lineHeight ?? 'var(--sizes-40)'};
      }

      > label {
        font: var(--font-extra-small-12pt-normal);
        margin-bottom: 5px;
        align-self: start;
      }
    `}

    ${$labelPlacement === 'bottom' &&
    css`
      flex-direction: column-reverse;

      > label {
        margin-top: 5px;
      }
    `}

    ${$labelPlacement === 'start' &&
    css`
      flex-direction: row;

      .MuiInputBase-input {
        font: var(--font-small-13pt-normal);
        line-height: ${$lineHeight ?? 'var(--sizes-40)'};
      }

      > label {
        font: var(--font-small-13pt-normal);
        line-height: var(--sizes-40);
        align-self: ${$multilineLabel ? 'start' : 'center'};
        margin-top: ${$multilineLabel ? 'var(--sizes-40)' : '0'};
        margin-bottom: 0;
      }
    `}

    ${$labelPlacement === 'end' &&
    css`
      flex-direction: row-reverse;
      > label {
        align-self: center;
        margin-left: 5px;
      }
    `}

    ${($labelPlacement === 'toggle' || $labelPlacement === 'image-uploader') &&
    css`
      > label {
        align-self: start;
        margin-top: 6px;
      }
    `}

    ${$fullWidth &&
    css`
      margin-bottom: 0;
      display: block;
    `}

    ${$labelPlacement === 'toggle-end' &&
    css`
      grid-template-columns: auto auto repeat(${Number($gridColumns || 6) - 2}, 1fr);
      > label {
        order: 2;
        align-self: center;
        margin-left: 5px;
        grid-column: auto;
      }
      > *:not(label) {
        order: 1;
        grid-column: auto;
      }
    `}
  `}
`;
